import type { RGB } from './types/rgb.type';

/**
 * Converts an RGB color object with alpha channel to a CSS rgba() string.
 *
 * @param {RGB} param0 - An object containing red, green, blue, and alpha values.
 * @returns {string} The CSS rgba() string representation of the color.
 */
export const rgbaToCss = ({ alpha = 1, blue, green, red }: RGB) => {
  if (alpha === 1) {
    return `rgb(${red}, ${green}, ${blue})`;
  }

  return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
};
